import React, { FC } from 'react';

//devextreem
import { Popup } from 'devextreme-react/popup';

import ModalFooter from '../../../../../components/appModalFooter';
import { useDeleteTransportMutation } from '../../../../../bus/transport/transport';
import { isSuccess } from '../../../../../utils/responseStatus';

type DetailModalRoleProps = {
  id: number | null;
  visible: boolean;
  changeVisible: (visible: boolean) => void;
  refresh: () => void;
};

const DetailModalRole: FC<DetailModalRoleProps> = (props) => {
  const [deleteTransport, { isLoading }] = useDeleteTransportMutation();

  const handleSubmit = async (e: any) => {
    e.preventDefault && e.preventDefault();
    await deleteTransport({ id: props.id! }).then((resp: any) => {
      if (isSuccess(resp)) {
        props.refresh();
        props.changeVisible(false);
      }
    });
  };

  const onShown = () => { };

  const onHiden = () => { };

  return (
    <div>
      <Popup
        visible={props.visible}
        onHiding={() => props.changeVisible(false)}
        dragEnabled={true}
        closeOnOutsideClick={false}
        showTitle={true}
        title="Подтвердите действие"
        width={400}
        onShowing={() => onShown()}
        onHidden={() => onHiden()}
        height={160}
      >
        <div className="modal-block">
          <form onSubmit={handleSubmit}>
            <div className="modal-block__content">Вы действительно хотите удалить транспорт?</div>

            <ModalFooter
              useSubmitBehavior={false}
              handleSubmit={handleSubmit}
              hideModal={() => props.changeVisible(false)}
              textConfirm="Удалить"
              typeConfirm="danger"
              disabledSubmit={isLoading}
            />
          </form>
        </div>
      </Popup>
    </div>
  );
};

export default DetailModalRole;
